import { Controller } from '@hotwired/stimulus'

// Inline edit toggle for a chat message bubble.
export default class extends Controller {
  static targets = ['display', 'editor', 'input']

  connect () {
    this._onKeydown = (event) => {
      if (event.key === 'Escape' && this.isEditing()) this.cancel(event)
    }
    document.addEventListener('keydown', this._onKeydown)
  }

  disconnect () {
    document.removeEventListener('keydown', this._onKeydown)
  }

  edit (event) {
    event?.preventDefault()
    if (!this.hasDisplayTarget || !this.hasEditorTarget) return

    this.displayTarget.classList.add('hidden')
    this.editorTarget.classList.remove('hidden')
    if (this.hasInputTarget) {
      this.inputTarget.focus({ preventScroll: true })
      const length = this.inputTarget.value.length
      this.inputTarget.setSelectionRange(length, length)
    }
  }

  cancel (event) {
    event?.preventDefault()
    if (!this.hasDisplayTarget || !this.hasEditorTarget) return

    this.editorTarget.classList.add('hidden')
    this.displayTarget.classList.remove('hidden')
  }

  isEditing () {
    return this.hasEditorTarget && !this.editorTarget.classList.contains('hidden')
  }
}
